import { Button, Grid, TextField, makeStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DeleteOutlined } from "@material-ui/icons";
import React, { useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { sendActionMail } from "../../../../services/actions.service";
import { ACTION_EMAIL_BODIES } from "../../../../utils/StaticLists";
import DialogCustom from "../../../Common/DialogCustom";
import Textarea from "../../../Common/Textarea";
import ToastMessage from "../../../Common/ToastMessage";
import { Dropzone, FilesContainer } from "./styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  button: {
    ...theme.typography.subtitle1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
    marginTop: "5vh",
  },
  spacer: {
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  titleModal: {
    color: "#031795",
    fontWeight: "bold",
    fontSize: "20px",
  },
}));

const SendActionEmailModal = ({ setModalStatus, onSucces, actionInfo, t }) => {
  const classes = useStyles();
  const emailsRef = useRef();

  const [toastMessage, setToastMessage] = useState({
    message: "",
    type: "error",
    open: false,
  });
  const [loading, setLoading] = useState(false);
  const [filesAnexo, setFilesAnexo] = useState([]);
  const [content, setContent] = useState(() => {
    const language = localStorage.getItem("i18nextLng");
    const content = ACTION_EMAIL_BODIES[language]
      .replaceAll("{{actionInfoCommitte}}", actionInfo?.committe)
      .replaceAll("{{actionInfoMeetDate}}", actionInfo?.meetDate)
      .replaceAll("{{actionInfoTheme}}", actionInfo?.theme)
      .replaceAll("{{actionInfoActionNumber}}", actionInfo?.actionNumber)
      .replaceAll(
        "{{actionInfoActionDescription}}",
        actionInfo?.actionDescription
      )
      .replaceAll("{{actionInfoDeadline}}", actionInfo?.deadline)
      .replaceAll(
        "{{actionInfoCompanies}}",
        actionInfo?.companies?.length > 0
          ? actionInfo?.companies?.map((cp) => cp.companyName).join(", ")
          : ""
      )
      .replaceAll("{{actionInfoCommittee}}", actionInfo?.committe);

    return content;
  });

  const handleCapture = async ({ target }) => {
    const listArquivos = [];
    const filesUploadedWithSameName = [];
    const filesWithSameName = [];

    for (const file of target.files) {
      const fileBase64 = await toBase64(file);

      const itemToInclude = {
        id: uuidv4(),
        name: file.name,
        contentType: file.type,
        contentByte: fileBase64.split(",")[1],
      };

      const fileWithSameName = filesAnexo.find(
        (fileAnexo) => file.name === fileAnexo.name
      );

      if (fileWithSameName) {
        filesUploadedWithSameName.push(itemToInclude);
        filesWithSameName.push(fileWithSameName);

        setOpenUploadSameFileDialog(true);
      } else {
        listArquivos.push(itemToInclude);
      }
    }

    if (filesUploadedWithSameName) {
      setFilesUploadedWithSameName(filesUploadedWithSameName, 1);
    }

    if (filesWithSameName) {
      setSameFilesUploaded(filesWithSameName);
    }

    setFilesAnexo([...filesAnexo, ...listArquivos]);
  };

  const handleRemoveFile = (item_id) => {
    const newFiles = filesAnexo.filter((file) => file.id !== item_id);

    setFilesAnexo(newFiles);
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const [isEmailsErrored, setIsEmailsErrored] = useState(
    actionInfo?.firstResponsibleEmail || actionInfo?.secoundResponsibleEmail
      ? false
      : true
  );

  const handleCloseUploadSameFileDialog = () => {
    setSameFilesUploaded([]);
    setOpenUploadSameFileDialog(false);
  };

  const handleReplaceSameFile = () => {
    if (sameFilesUploaded.length > 0) {
      const fileIdssWithSameName = sameFilesUploaded.map(
        (sameFile) => sameFile.id
      );
      const newFilesAnexoList = filesAnexo.filter(
        (file) => !fileIdssWithSameName.includes(file.id)
      );

      setFilesAnexo([...newFilesAnexoList, ...filesUploadedWithSameNameState]);
      setSameFilesUploaded([]);
      setFilesUploadedWithSameName([]);
    }

    setOpenUploadSameFileDialog(false);
  };

  const [filesUploadedWithSameNameState, setFilesUploadedWithSameName] =
    useState([]);
  const [sameFilesUploaded, setSameFilesUploaded] = useState([]);
  const [openUploadSameFileDialog, setOpenUploadSameFileDialog] =
    useState(false);

  const [fileOver, setFileOver] = useState(false);

  const dragOver = (e) => {
    setFileOver(true);

    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    setFileOver(false);

    e.preventDefault();
  };

  const fileDrop = async (e) => {
    setFileOver(false);
    e.preventDefault();

    const files = e.dataTransfer.files;

    const listArquivos = [];
    const filesUploadedWithSameName = [];
    const filesWithSameName = [];

    for (const file of files) {
      const fileBase64 = await toBase64(file);

      const itemToInclude = {
        id: uuidv4(),
        name: file.name,
        contentType: file.type,
        contentByte: fileBase64.split(",")[1],
      };

      const fileWithSameName = filesAnexo.find(
        (fileAnexo) => file.name === fileAnexo.name
      );

      if (fileWithSameName) {
        filesUploadedWithSameName.push(itemToInclude);
        filesWithSameName.push(fileWithSameName);

        setOpenUploadSameFileDialog(true);
      } else {
        listArquivos.push(itemToInclude);
      }
    }

    if (filesUploadedWithSameName) {
      setFilesUploadedWithSameName(filesUploadedWithSameName, 1);
    }

    if (filesWithSameName) {
      setSameFilesUploaded(filesWithSameName);
    }

    setFilesAnexo([...filesAnexo, ...listArquivos]);
  };

  const sendEmail = () => {
    setLoading(true);

    if (!emailsRef || emailsRef?.current?.value?.length <= 0) {
      setToastMessage({
        message: t("meeting.AttentesRequerid"),
        type: "error",
        open: true,
      });
      setLoading(false);
      return;
    }

    const formattedRecipients = emailsRef?.current?.value
      ?.split(";")
      ?.map((email) => ({
        address: email.replaceAll(" ", ""),
      }))
      .filter((e) => e.address !== "");

    const emailValidator =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let isEmailsValid = true;

    formattedRecipients.forEach((email) => {
      if (!emailValidator.test(String(email.address).toLowerCase())) {
        isEmailsValid = false;
      }
    });

    if (!isEmailsValid) {
      setToastMessage({
        open: true,
        message: "Email inválido.",
        type: "error",
      });
      setLoading(false);

      return;
    }

    let body = {
      content: content,
      recipients: formattedRecipients,
      minuteActionId: actionInfo.id,
      attachments: filesAnexo.map((file) => ({
        name: file.name,
        contentType: file.contentType,
        contentByte: file.contentByte,
      })),
    };

    sendActionMail(body).then((res) => {
      if (res?.error?.length > 0) {
        setToastMessage({
          message: t("meeting.ErrorMetting"),
          type: "error",
          open: true,
        });
        setLoading(false);

        return;
      }

      onSucces();
      setLoading(false);
    }).catch(() => {
      setToastMessage({
        message: t("meeting.ErrorMetting"),
        type: "error",
        open: true,
      });
      setLoading(false);
    });
  };

  return (
    <div>
      <DialogCustom
        open={openUploadSameFileDialog}
        handleClose={handleCloseUploadSameFileDialog}
        handleChange={handleReplaceSameFile}
        title={t(`forms.dialog.alert`)}
        body={t("forms.dialog.uploadSameFile")}
        confirmText={t(`forms.dialog.yes`)}
        cancelText={t(`forms.dialog.no`)}
        alert={true}
      />
      <span
        style={{ float: "right", cursor: "pointer" }}
        onClick={() => {
          setModalStatus(false);
        }}
      >
        [X] Fechar
      </span>

      <div className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <Textarea
              name="for"
              id="for"
              label={t("forms.forLabel")}
              error={isEmailsErrored}
              textAreaRef={emailsRef}
              defaultValue={
                actionInfo?.firstResponsibleEmail ||
                actionInfo?.secoundResponsibleEmail
                  ? `${
                      actionInfo?.firstResponsibleEmail
                        ? actionInfo?.firstResponsibleEmail
                        : ""
                    };${
                      actionInfo?.secoundResponsibleEmail
                        ? actionInfo?.secoundResponsibleEmail
                        : ""
                    }`
                  : ""
              }
              onChange={(event) => {
                if (!event.target.value) {
                  setIsEmailsErrored(true);
                } else if (isEmailsErrored) {
                  setIsEmailsErrored(false);
                }
              }}
            />
          </Grid>
        </Grid>

        <center>
          <Grid>
            <Button
              variant="contained"
              color="primary"
              component="label"
              style={{ width: "20%", marginTop: "2%" }}
              fullWidth
            >
              {t("forms.attachFiles")}
              <input
                type="file"
                hidden
                multiple
                onClick={(event) => {
                  event.target.value = null;
                }}
                onChange={handleCapture}
              />
            </Button>

            <Dropzone
              onDragOver={dragOver}
              onDragEnter={dragEnter}
              onDragLeave={dragLeave}
              onDrop={fileDrop}
              style={fileOver ? { borderColor: "#465eb6" } : {}}
            >
              <p>{t("forms.dragFilesHere")}</p>
            </Dropzone>
          </Grid>

          <Grid item lg={12} xs={12}>
            {filesAnexo.map((item) => (
              <FilesContainer key={item.id}>
                <p>{item.name}</p>
                <DeleteOutlined onClick={() => handleRemoveFile(item.id)} />
              </FilesContainer>
            ))}
          </Grid>
        </center>

        <TextField
          style={{ width: "100%", marginTop: "1%" }}
          placeholder={t("forms.bodyEmailPlaceholder")}
          multiline
          rowsMin={10}
          maxRows={10}
          value={content}
          onChange={(event, newValue) => {
            setContent(event.target.value);
          }}
        />

        <Grid
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginTop: "36px",
          }}
        >
          <Button
            style={{ width: "20%" }}
            color="primary"
            variant="contained"
            onClick={() => sendEmail()}
          >
            {loading ? (
              <CircularProgress size={24} color="white" />
            ) : t("meeting.Send")}
          </Button>
        </Grid>
      </div>

      <ToastMessage
        message={toastMessage.message}
        type={toastMessage.type || "error"}
        open={toastMessage.open}
        close={() => setToastMessage({ ...toastMessage, open: false })}
      />
    </div>
  );
};

export default SendActionEmailModal;
